























import { Component, Vue } from "vue-property-decorator";
import competitionBanner from "./components/competitionBanner/index.vue";
import competitionCalendar from "../components/competitionCalendar/index.vue";
import homeZone from "./components/homeZone.vue";
import { MatchArea } from "@/req/competitionEvent";
@Component({
  components: { competitionBanner, competitionCalendar, homeZone },
})
export default class Home extends Vue {
  public dataList: any = [];

  public page = 1;
  public size = 10;
  public total = 0;
  public bgImg = require("@/assets/icons/competition/home_bg2.jpg");

  public mounted() {
    this.getData();
    setTimeout(() => {
      for (const item of this.dataList) {
        if (item.matchInfo.length > 6) {
          // this.$fn.competitionRecord(
          //   "saishituijian",
          //   "saishituijian_11",
          //   "saishituijian_11_1"
          // );
          return;
        }
      }
    }, 500);
    // (this as any).$pc.pcTestSendOpen(); // 通知盒子打开页面了
    window.addEventListener("scroll", this.add);
  }

  public async getData() {
    const obj: any = {
      token: this.$fn.cookies.getToken(),
      page: this.page,
      size: this.size,
    };
    const res = await MatchArea(obj);
    if (res.code == 200) {
      this.dataList = [...this.dataList, ...res.data.data];
      this.total = res.data.total;
      setTimeout(() => {
        const $homeContentBox: any = this.$refs.homeContentBox;
        if ($homeContentBox.offsetHeight < 1000) {
          this.bgImg = require("@/assets/icons/competition/home_bg_replace.jpg");
        }
      }, 500);
    }
  }

  public add() {
    const a = document.documentElement.scrollTop;
    const b = document.documentElement.clientHeight;
    const c = document.documentElement.scrollHeight;
    if (c - a - b < 1) {
      if (this.total > this.dataList.length) {
        this.page = this.page + 1;
        this.getData();
      }
    }
  }
}
